import { Chip, ChipProps } from "@mui/material";
import * as React from "react";

interface CustomChipsProps extends ChipProps {
  label: string;
  type?: "success" | "error";
  variant?: "filled" | "outlined";
  size?: "small" | "medium";
  fullWidth?: boolean;
  onClick?: any;
}

const CustomChip = ({
  label,
  type = "success",
  size = "small",
  variant = "filled",
  fullWidth = false,
  onClick,
}: CustomChipsProps) => {
  const colors = {
    success: {
      color: "#07BC2A",
      bgColor: "#EDF7EE",
    },
    error: {
      color: "#FF890A",
      bgColor: "#FFF0DF",
    },
  };

  const colorHash = colors[type];

  return (
    <Chip
      label={label}
      size={size}
      variant={variant}
      sx={{
        "&.MuiChip-root": {
          px: 1,
          textTransform: "capitalize",
          backgroundColor: colorHash?.bgColor,
          color: colorHash?.color,
          width: fullWidth ? "100%" : undefined,
          borderRadius: "16px",
          fontSize: "8px",
          fontWeight: 600,
          textDecoration: "none",
          userSelect: "none",
          height: "16px",
        },
      }}
      onClick={onClick}
    />
  );
};

export default CustomChip;
